<template>
  <div>
    <p mb-0>
      {{ $t('errors.error_404.content') }}
    </p>
    <v-layout justify-center>
      <v-btn
        style="margin-left: -28px"
        color="sz_transparent_red"
        @click="redirect()"
      >
        {{ $t('buttons.ok') }}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
export default {
    name: 'ErrorPage404',
    methods: {
        redirect () {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped></style>
